// 英文翻译
const en = {
  nav: {
    products: 'Products',
    ipTransit: 'IP Transit',
    cloudVM: 'Cloud VM',
    bareMetal: 'Bare Metal',
    sdwan: 'SD-WAN',
    network: 'Network',
    globalNetwork: 'Global Network',
    locations: 'Locations',
    latency: 'Latency',
    ddosShield: 'DDoS Shield',
    company: 'Company',
    about: 'About',
    careers: 'Careers',
    pricing: 'Pricing'
  },
  footer: {
    product: 'Product',
    network: 'Network',
    company: 'Company',
    support: 'Support',
    terms: 'Terms',
    ipTransit: 'IP Transit',
    cloudVM: 'Cloud VM',
    bareMetal: 'Bare Metal',
    sdwan: 'SD-WAN',
    globalNetwork: 'Global Network',
    locations: 'Locations',
    latency: 'Latency',
    ddosShield: 'DDoS Shield',
    about: 'About',
    careers: 'Careers',
    contactSupport: 'Contact Support',
    contactSales: 'Contact Sales',
    documentation: 'Documentation',
    networkStatus: 'Network Status',
    termsOfService: 'Terms of Service',
    compliance: 'Compliance',
    privacyPolicy: 'Privacy Policy',
    serviceLevel: 'Service Level',
    systemStatus: 'All systems are running.',
    startTitle: 'Start for Free, Scale as You Grow',
    requestTest: 'Request test',
    learnMore: 'Learn more about network'
  },
  home: {
    motto: 'Creativity. Trust. Communication.',
    title: {
      line1: 'Empowering Business',
      line2: 'Growth with Premium',
      line3: 'Network'
    },
    subtitle: 'Accelerating the Future of Digital Infrastructure',
    requestTest: 'Request test',
    learnMore: 'Learn more about network',
    networkSection: {
      title: 'Robust Global Network',
      subtitle: 'Globally Distributed Access Points, Robust and Reliable Network'
    },
    features: {
      isp: {
        title: 'Connected with major tier 1/2 ISPs.',
        desc: 'Access global tier 1 ISP network with no commitment.'
      },
      scale: {
        title: 'Scale anytime.',
        desc: 'Large. Small. Scale.'
      },
      ddos: {
        title: 'DDoS Shield.',
        desc: 'Blocking Malicious Traffic at the Edge.'
      },
      network: {
        title: 'Superb Network, Unmatched Performance.',
        desc: 'Ensuring seamless connectivity, robust reliability, and exceptional speed.'
      }
    },
    deploy: {
      title: 'Deploy Applications',
      subtitle: 'Closer to End Users',
      desc: 'Our global edge is connected with local eyeball ISPs, brings lowest latency to end users'
    },
    advantage: {
      title: 'Why Us?',
      desc: {
        line1: 'Low latency, built-in DDoS protection, 24/7 bilingual support,',
        line2: 'and global connectivity through a premium network.'
      },
      items: {
        latency: {
          title: 'Low Latency',
          desc: 'Minimal hops. Short routes. Our network was built for real-time.'
        },
        ddos: {
          title: 'DDoS Shield',
          desc: 'Blocking Malicious Traffic at the Edge by default.'
        },
        support: {
          title: 'Full Support',
          desc: '24/7 all day bilingual support in English and Chinese.'
        },
        reach: {
          title: 'Global Reach',
          desc: 'Reach global users with our premium network.'
        },
        ips: {
          title: 'Local IPs',
          desc: 'Deliver IPs from local eyeball ISPs to fulfill connectivity needs.'
        },
        ixp: {
          title: 'IXP',
          desc: 'Exchange traffic locally at major local IXPs.'
        },
        elastic: {
          title: 'Elastic',
          desc: 'Highly scalable and affordable when you grow.'
        },
        dci: {
          title: 'DCI',
          desc: 'Data Center Interconnection with speed up to 800Gbps.'
        }
      }
    },
    deployFeatures: {
      ipTransit: {
        title: 'IP Transit',
        description: 'State-of-the-art global IP transit designed for network operators.'
      },
      bareMetal: {
        title: 'Bare Metal',
        description: 'Dedicated servers powered by high-performance processors.'
      },
      cloudVM: {
        title: 'Cloud VMs',
        description: 'Highly scalable and affordable computing power, starting at $5 per month.'
      }
    }
  },
  pricing: {
    title: 'Simple Pricing',
    desc: {
      line1: "Always know what you'll pay with monthly caps and flat pricing.",
      line2: 'Talking to our sales team for custom solution.'
    },
    features: {
      credit: {
        title: '$50 Credit',
        desc: 'Register to get $5 credit to order Cloud VMs for 60 days.'
      },
      delivery: {
        title: 'Instant Delivery',
        desc: 'Ready for use within minutes in multiple lications.'
      },
      network: {
        title: 'Premium Network',
        desc: 'Premium IP Transit for the Future of Digital Infrastructure.'
      },
      performance: {
        title: 'Performance',
        desc: 'Intel® Xeon® servers ensure performance and reliability.'
      }
    },
    tabs: {
      network: 'Network',
      compute: 'Compute'
    },
    ipTransit: {
      title: 'IP Transit',
      subtitle: 'Estimate monthly IP Transit cost',
      commitment: 'Gbps commitment',
      price: ' / mo, billed in advance',
      priceNote: '*Committed bandwidth will be billed in advance, while burstable usage will be calculated and billed on the first day of the following month.',
      features: {
        loa: 'LoA in one day',
        support: '24 x 7 all day support',
        billing: '95th percentile billing',
        storage: 'Object Storage'
      }
    },
    connect: {
      title: 'Connect to Our Network',
      subtitle: 'is Easy',
      desc: 'IP Transit is available in the following data centers—simply set\nup a cross-connect to connect with us.',
      actions: {
        sales: 'Talking to Sales Team',
        test: 'Request LoA for Testing'
      }
    },
    compute: {
      name: 'Name',
      vcpu: 'vCPU',
      ram: 'RAM',
      ssd: 'SSD',
      traffic: 'Traffic',
      bandwidth: 'Bandwidth',
      monthly: 'Monthly'
    }
  },
  network: {
    ddosShield: {
      title: 'DDoS Shield',
      subtitle: 'Enabled by Default',
      description: 'Blocking Malicious Traffic at the Edge.'
    },
    global: {
      title: {
        line1: 'High Availability',
        line2: 'Network Typology'
      },
      subtitle: 'Accelerating the Future of Digital Infrastructure',
      buttons: {
        lookingGlass: 'Looking Glass >',
        peeringDB: 'PeeringDB >'
      },
      features: {
        redundantDesign: {
          title: 'Redundant Design',
          description: 'Multiple upstream feeds design ensures high reliability for the target ISP. Routing automatically switches to available paths.'
        },
        dci: {
          title: 'Data Center Interconnection',
          description: 'Self-built DCI guarantees uninterrupted internet connectivity across different data centers within the same city.'
        },
        monitoring: {
          title: 'Real-Time Traffic Monitoring',
          description: 'Over 50 network monitoring points with automated alerts, and dynamic routing to ensure traffic is transmitted via the optimal path.'
        },
        isps: {
          title: 'Connected with top local ISPs',
          description: 'Direct connections to the top local carriers in each region enhance network performance.'
        }
      },
      connect: {
        title: 'Connect with Global End',
        subtitle: 'Users Faster',
        description: 'Our global edge is connected with local eyeball ISPs, brings lowest latency to end users'
      },
      easyConnect: {
        title: 'Connect to Our Network',
        subtitle: 'is Easy',
        description: 'IP Transit is available in the following data centers—simply set\nup a cross-connect to connect with us.',
        buttons: {
          sales: 'Talking to Sales Team',
          test: 'Request LoA for Testing'
        }
      }
    },
    latency: {
      title: {
        line1: 'Near Real-Time',
        line2: 'Performance'
      },
      subtitle: 'Accelerating the Future of Digital Infrastructure',
      buttons: {
        lookingGlass: 'Looking Glass >',
        peeringDB: 'PeeringDB >'
      }
    },
    locations: {
      title: {
        line1: 'Connect to Our Network',
        line2: 'is Easy'
      },
      subtitle: 'IP Transit is available in the following data centers—simply set\nup a cross-connect to connect with us.',
      actions: {
        sales: 'Talking to Sales Team',
        test: 'Request LoA for Testing'
      }
    }
  },
  company: {
    about: {
      title: {
        line1: 'Leading Network',
        line2: 'Across APAC.'
      },
      subtitle: 'Accelerating the Future of Digital Infrastructure',
      stats: {
        upstreamFeed: {
          number: '3Tbps',
          label: 'Upstream Feed'
        },
        networkCores: {
          number: '12',
          label: 'Network Cores'
        },
        connectedPeers: {
          number: '2000',
          label: 'Connected Peers'
        },
        upstreamCapacity: {
          number: '3Tbps',
          label: 'Upstream Capacity'
        }
      },
      sections: {
        coreProduct: 'Our Core Product',
        networkFeeds: 'Our Network Feeds',
        corePops: 'Our Core Pops'
      }
    },
    careers: {
      title: {
        line1: 'Join Us to Build',
        line2: 'Better Network'
      },
      subtitle: 'Blocking Malicious Traffic at the Edge.',
      features: {
        remote: {
          title: 'Completely Remote',
          description: 'Work remotely without the hassle of clocking in or out, and there\'s no need for tedious daily or weekly reports.',
          locations: {
            office: 'Office',
            home: 'Home',
            or: 'or'
          }
        },
        benefits: {
          title: 'Competitive salary',
          description: 'Competitive salary with comprehensive benefits, including insurance and housing funds.',
          items: {
            salary: {
              title: 'Salary',
              description: 'Competitive salary for excellence.'
            },
            insurance: {
              title: 'Insurance',
              description: 'Endowment, Medical, Unemployment, Child and work-related injury insurance'
            },
            fund: {
              title: 'Fund',
              description: 'Housing accumulation funds'
            }
          }
        }
      },
      jobs: {
        title: 'Current Job Openings',
        details: {
          jobType: 'Job Type',
          location: 'Location',
          headcount: 'Headcount'
        },
        positions: {
          procurement: {
            title: 'Procurement Assistant',
            type: 'Full Time',
            location: 'Chengdu / Xiamen, China',
            headcount: '1'
          },
          businessDev: {
            title: 'Business Development Representative',
            type: 'Full Time',
            location: 'Guangzhou / Shenzhen / Beijing',
            headcount: '3'
          }
        },
        talkButton: 'Talk to Us'
      }
    }
  },
  products: {
    ipTransit: {
      title: {
        line1: 'Premium IP Transit',
        line2: 'for Global Reach'
      },
      subtitle: 'Accelerating the Future of Digital Infrastructure',
      buttons: {
        lookingGlass: 'Looking Glass >',
        peeringDB: 'PeeringDB >'
      },
      features: {
        latency: {
          title: 'Low Latency',
          description: 'Minimal hops. Short routes. Our network was built for real-time.'
        },
        reach: {
          title: 'Global Reach',
          description: 'Reach global users with our premium network.'
        },
        elastic: {
          title: 'Elastic',
          description: 'Highly scalable and affordable when you grown.'
        },
        ixp: {
          title: 'IXP',
          description: 'Exchange traffic locally at major local IXPs.'
        }
      },
      network: {
        title: {
          line1: 'Connect with Global End',
          line2: 'Users Faster'
        },
        description: 'Our global edge is connected with local eyeball ISPs, brings lowest latency to end users'
      },
      connect: {
        title: {
          line1: 'Connect to Our Network',
          line2: 'is Easy'
        },
        description: 'IP Transit is available in the following data centers—simply set up a cross-connect to connect with us.',
        buttons: {
          sales: 'Talking to Sales Team',
          test: 'Request LoA for Testing'
        }
      },
      specs: {
        title: 'Specifications',
        items: {
          commitment: {
            label: 'Commitment',
            value: '100Mbps to 3Tbps'
          },
          burstable: {
            label: 'Burstable',
            value: '95th Percentile Bursting\n1:10 ratio'
          },
          crossConnect: {
            label: 'Cross Connect',
            value: 'Provided by customer\nor prepaid for one year'
          },
          fiber: {
            label: 'Fiber',
            value: 'Single mode fibre, 2 cores'
          },
          connector: {
            label: 'Connector Type',
            value: 'LC'
          },
          lacp: {
            label: 'LACP',
            value: 'Supported'
          },
          bgp: {
            label: 'BGP',
            value: 'BGP full table'
          },
          bgpCommunities: {
            label: 'BGP Communities',
            value: 'BGP Communities vary based on the service type'
          },
          ddos: {
            label: 'DDoS Shield',
            value: 'Default 10Gbps shield\nUp to 1Tbps DDoS Protection Capability'
          },
          ipv4: {
            label: 'IPv4',
            value: 'Provided by customer\n or $150 per /24 by AS9886\n or talk to Sales Team for more details'
          },
          ipv6: {
            label: 'IPv6',
            value: 'Provided by customer<br>or one free /48'
          }
        }
      }
    },
    sdwan: {
      title: {
        line1: 'Expand SD-WAN',
        line2: 'Coverage'
      },
      subtitle: 'SD-WAN Enabler empowers customers to rapidly expand their global network footprint. Scalable backbone and IPLC, or provide enhanced SaaS acceleration services, CTCSCI offers a comprehensive solution.',
      features: {
        premiumNetwork: {
          title: 'Premium Network',
          description: 'The SDN backbone provides low-latency, high-reliability, and protected connections, ensuring superior service performance and stability.',
          stats: {
            hkToSg: 'Hong Kong to Singapore',
            hkToTokyo: 'Hong Kong to Tokyo',
            tokyoToSeoul: 'Tokyo to Seoul',
            hkToSeoul: 'Hong Kong to Seoul',
            cnToHk: 'China to Hong Kong',
            cnToTokyo: 'China to Tokyo',
            cnToUs: 'China to US',
            cnToSg: 'China to Singapore'
          },
          tabs: {
            backbone: 'Backbone',
            iplc: 'IPLC'
          }
        },
        globalCoverage: {
          title: 'Global Coverage',
          description: 'Extensive global dedicated line coverage and a rich array of nodes fully meet all your infrastructure resource needs.'
        },
        flexibleDeployment: {
          title: 'Flexible Deployment',
          description: 'Enable rapid deployment and flexible scaling with business growth. Supports various deployment options, including BMC and VM.',
          options: {
            bareMetal: 'Bare Metal',
            cloudVM: 'Cloud VM'
          }
        },
        compliance: {
          title: 'Compliance',
          description: 'Comprehensive resources and operational qualifications ensure compliance for cross-border operations.',
          certs: {
            iso27001: {
              name: 'ISO27001',
              number: '416Z4ISZ060ZR0'
            },
            iso9001: {
              name: 'ISO9001',
              number: '416Z4QZ636ZER0'
            },
            sro: {
              name: 'SRO',
              number: 'No.1906'
            }
          }
        }
      }
    },
    cloudVM: {
      title: {
        line1: 'Unlimited Flexibility',
        line2: 'in the Cloud'
      },
      subtitle: 'Seamless Virtual Computing with Unmatched Scalability and Flexibility.',
      features: {
        locations: {
          title: '10+ locations',
          description: 'Bare Metal servers available in 10 data centers'
        },
        delivery: {
          title: 'Instant Delivery',
          description: 'Ready for use within minutes in multiple locations.'
        },
        network: {
          title: 'Premium Network',
          description: 'Premium IP Transit for the Future of Digital Infrastructure.'
        },
        performance: {
          title: 'Performance',
          description: 'Intel® Xeon® servers ensure performance and reliability.'
        }
      },
      apacNetwork: {
        title: {
          line1: 'Powered by a Low-Latency',
          line2: 'Premium Network.'
        },
        description: {
          line1: 'Instant local and global reach with our expanding network and',
          line2: 'data center presence, delivering near real-time precision.'
        },
        button: 'Learn more about our presence'
      },
      dataCenters: {
        hongKong: {
          name: 'Hong Kong, China',
          detail: 'Bare Metal at 2 Data Center'
        },
        singapore: {
          name: 'Singapore',
          detail: 'Bare Metal at 3 Data Center'
        }
      },
      pricing: {
        title: {
          line1: 'Get More Resources at',
          line2: 'Lower Cost'
        },
        description: 'Get more traffic and bandwidth at a lower cost compared to industry competitors.',
        button: 'Check Cloud VM Pricing',
        bestChoice: 'Best Choice',
        comparison: {
          specs: '1 vCPU, 1GB, 25GB',
          bandwidth: 'Bandwidth',
          network: '10Gbps',
          price: '$5 / mo'
        },
        competitors: {
          digitalOcean: {
            specs: '1 vCPU, 1GB, 25GB',
            bandwidth: 'Bandwidth 1TB',
            network: '1Gbps',
            price: '$5 / mo'
          },
          vultr: {
            specs: '1 vCPU, 1GB, 25GB',
            bandwidth: 'Bandwidth 1TB',
            network: '1Gbps',
            price: '$6 / mo'
          },
          zenlayer: {
            specs: '1 vCPU, 2GB, 25GB',
            bandwidth: 'Bandwidth 1TB',
            network: '1Gbps',
            price: '$17.272 / mo'
          }
        }
      }
    },
    bareMetal: {
      title: {
        line1: 'Unmatched Edge',
        line2: 'Performance'
      },
      subtitle: 'Bare Metal servers available in 10 data centers with minute-level deployment.',
      features: {
        locations: {
          title: '10+ locations',
          description: 'Bare Metal servers available in 10 data centers'
        },
        delivery: {
          title: 'Instant Delivery',
          description: 'Ready for use within minutes in multiple locations.'
        },
        network: {
          title: 'Premium Network',
          description: 'Premium IP Transit for the Future of Digital Infrastructure.'
        },
        performance: {
          title: 'Performance',
          description: 'Intel® Xeon® servers ensure performance and reliability.'
        }
      },
      reachUsers: {
        title: 'Quickly Reach Users in Emerging Markets',
        subtitle: 'A leading Chinese CDN provider reduced latency by 50% for end users across ASEAN through AS9886.',
        button: 'Check Bare Metal Pricing'
      },
      apacNetwork: {
        title: {
          line1: 'Powered by a Low-Latency',
          line2: 'Premium Network.'
        },
        description: {
          line1: 'Instant local and global reach with our expanding network and',
          line2: 'data center presence, delivering near real-time precision.'
        },
        button: 'Learn more about our presence'
      },
      dataCenters: {
        hongKong: {
          name: 'Hong Kong, China',
          detail: 'Bare Metal at 2 Data Center'
        },
        singapore: {
          name: 'Singapore',
          detail: 'Bare Metal at 3 Data Center'
        }
      },
      useCases: {
        title: {
          line1: 'Tailored Performance for Your',
          line2: 'Use Case'
        },
        cases: {
          business: {
            title: 'Business',
            description: 'Great for business website & API hosting.'
          },
          vps: {
            title: 'VPS Hosting',
            description: 'Blocking Malicious Traffic at the Edge by default.'
          },
          gaming: {
            title: 'Gaming',
            description: 'The fastest platform to run your games on.'
          },
          cdn: {
            title: 'CDN',
            description: 'Minimum 0.5ms to Hong Kong Exchange.'
          },
          crypto: {
            title: 'Crypto',
            description: 'Future-ready infra for the future of finance'
          }
        }
      },
      specifications: {
        title: 'Specifications',
        items: {
          cpu: {
            label: 'CPU',
            value: 'Intel Xeon E / Silver / Gold'
          },
          cores: {
            label: 'Cores',
            value: 'Up to 32 Cores'
          },
          ram: {
            label: 'RAM',
            value: 'Up to 384 GB'
          },
          storage: {
            label: 'Storage',
            value: 'SSD / NVMe / HDD'
          },
          network: {
            label: 'Network Interface',
            value: '1Gbps / 10Gbps / 25Gbps, Ethernet'
          },
          ipv4: {
            label: 'IPv4',
            value: '1 free IPv4 address'
          },
          ipv6: {
            label: 'IPv6',
            value: '/64 IPv6 addresses'
          },
          traffic: {
            label: 'Traffic',
            value: 'Unmetered'
          },
          bandwidth: {
            label: 'Bandwidth',
            value: 'First 50Mbps free, additional bandwidth allocated on request'
          },
          customization: {
            label: 'Customization',
            value: 'Talk to Sales Team'
          }
        }
      }
    }
  },
  terms: {
    service: {
      title: 'Terms of Service',
      menu: {
        definition: 'Terms and Definitions',
        rights: 'Rights and Obligations',
        serviceContent: 'Service Content, Fees and Payment',
        period: 'Contract Period',
        changes: 'Business Changes, Contract Termination',
        breach: 'Breach of Contract',
        dispute: 'Dispute Resolution',
        force: 'Force Majeure',
        confidential: 'Confidentiality',
        rightsReserve: 'Rights Reserved',
        notification: 'Notification',
        law: 'Applicable Law',
        effective: 'Effective Conditions and Others'
      },
      content: {
        definition: {
          title: 'Terms and Definitions',
          text: [
            'These Terms of Service constitute a contract between wanix and you. The terms include this document and wanix Privacy Terms, as well as other terms or conditions related to specific service products that may be provided to you from time to time and that you accept (collectively referred to as "Terms of Service" or "Terms"). By registering or using our services, you will be deemed to accept these terms and agree to be bound by this contract.',
            'You, the account owner, are one party to the contract, referred to herein as "you" or "your". wanix, "Hangzhou Baozi Information Technology Co., Ltd." providing services to you, is the other party to the contract, referred to as "we", "us" or other first person pronouns.',
            'wanix software (as defined below), wanix services and other products, services and websites hosted or provided by wanix, such as our management backend and help and/or terms mentioned "services". Through them, you can do many things you want to do on network devices and systems (collectively, "Services"). In exchange for being able to use the Service, you agree to comply with these Terms.',
            'These Terms may be revised as new features, technologies appear or as required by laws and regulations, so please check from time to time. If we make significant changes, we will notify you and seek your consent when necessary. If we update these Terms, you have the right to decide whether to accept the updated Terms or stop using our Services (see "How to close my account" below); your continued use of the Service after the update takes effect will be deemed to constitute your agreement with us on the new Terms and agreement to be bound by them. Except for changes made by us as described herein, any other revision or modification to these Terms will be invalid unless you and we explicitly revise these Terms and have a written agreement with signatures. For clarity, emails or other communications will not constitute a valid written agreement for this purpose.',
            'If you have a separate written contract with wanix, the written contract shall prevail.'
          ]
        },
        rights: {
          title: 'Rights and Obligations',
          subtitle: 'Your Rights and Obligations',
          text: [
            'When using servers in the People\'s Republic of China, you promise to comply with the "Computer Information Network International Internet Security Protection Management Measures", "Interim Provisions on the Management of International Internet of Computer Information Networks of the People\'s Republic of China", "Telecommunications Regulations of the People\'s Republic of China", "Decision of the Standing Committee of the National People\'s Congress on Maintaining Internet Security", "Internet Information Service Management Measures", "Interim Provisions on the Administration of Internet Culture" and other relevant national laws, regulations, administrative provisions, and administrative rules, and shall not produce, copy, publish, or disseminate any harmful information prohibited by laws and regulations. You shall bear full responsibility for any political responsibility, legal responsibility and economic losses caused to us due to your business conduct and published information violating the above regulations.',
            'You promise not to use the services provided by wanix to engage in activities on the Internet that are prohibited by national laws, regulations or public morals or are unwelcome, and also promise not to provide any convenience for others to publish information content that does not comply with national regulations and/or the provisions of these terms. You understand that we have the right to decide based on our own prudent judgment whether the content you publish constitutes a violation of the terms of use or relevant national regulations and accordingly stop your service, and you shall bear the consequences arising therefrom. The above activities and information include but are not limited to:'
          ]
        }
      }
    }
  },
  essentialFeatures: {
    title: {
      line1: 'All the Essential Features',
      line2: 'of the Cloud'
    },
    subtitle: {
      line1: 'A complete suite of essential features to address a wide range of',
      line2: 'business and operational requirements'
    },
    features: [
      'Instant Delivery',
      'High Performance',
      'Low-latency',
      'ZStack Powered',
      'Latency optimized',
      'Backups & Snapshots',
      'Floating IPs',
      'Multiple Linux Image',
      'Object Storage',
      'Load Balancers',
      'DDoS Shield',
      '24 x 7 All Day Support'
    ]
  },
  globalPresence: {
    apac: {
      title: {
        line1: 'Available across APAC',
        line2: 'and beyond.'
      },
      description: {
        line1: 'Instant local and global reach with our expanding network and',
        line2: 'data center presence, delivering near real-time precision.'
      },
      button: 'Learn more about our presence'
    },
    locations: {
      hongKong: {
        name: 'Hong Kong, China',
        services: 'IP Transit, Cloud VM, Bare Metal'
      },
      singapore: {
        name: 'Singapore',
        services: 'IP Transit, Cloud VM, Bare Metal'
      },
      seoul: {
        name: 'Seoul, South Korea',
        services: 'IP Transit'
      },
      losAngeles: {
        name: 'Los Angeles, USA',
        services: 'IP Transit, Cloud VM'
      },
      tokyo: {
        name: 'Tokyo, Japan',
        services: 'IP Transit, Cloud VM'
      },
      jakarta: {
        name: 'Jakarta, Indonesia',
        services: 'Coming Soon'
      }
    }
  },
  latencyComparison: {
    tabs: {
      before: 'Before',
      after: 'After'
    },
    label: 'Latency',
    countries: {
      indonesia: 'Indonesia',
      malaysia: 'Malaysia',
      philippines: 'Philippines',
      singapore: 'Singapore',
      thailand: 'Thailand',
      vietnam: 'Vietnam'
    },
    ddos: {
      title: 'DDoS Shield.',
      description: 'Successfully mitigated multiple DDoS attacks, handling peak traffic of 500Gbps.'
    }
  },
  networkConnect: {
    table: {
      headers: {
        city: 'City',
        dataCenter: 'Data Center',
        portAvailability: 'Port Availability'
      }
    },
    locations: {
      hongKong: {
        name: 'Hong Kong',
        centers: [
          'Equinix HK1 / HK2 / HK3',
          'iAdvantage MEGA-i',
          'iAdvantage MEGA Two',
          'iAdvantage MEGA Gateway',
          'HKColo'
        ]
      },
      singapore: {
        name: 'Singapore',
        centers: [
          'Equinix SG1 / SG2 / SG3',
          'Global Switch Tai Seng',
          'China Mobile International Tai Seng'
        ]
      },
      tokyo: {
        name: 'Tokyo',
        centers: ['Equinix TY6 / TY8 / TY9']
      },
      losAngeles: {
        name: 'Los Angeles',
        centers: ['CoreSite LA2']
      }
    },
    portType: '10G / 100G, fiber'
  },
  networkLatency: {
    title: {
      line1: 'Check Network Latency',
      line2: 'to Major Eyeballs'
    },
    description: 'Check latency from our network to global major eyeball ISPs. You can also use https://check.my/mtr/ctcsci tool to get routing details from our network to target IPs.',
    locations: [
      { value: '103.77.210.191', label: 'Equinix HK1' },
      { value: '104.251.232.134', label: 'Singpore, Equinix SG1' },
      { value: '104.251.228.141', label: 'Tokyo, Equinix TY8' },
      { value: '104.251.238.134', label: 'Los Angeles, CoreSite LA2' },
      // { value: 'hk-eq1', label: 'Equinix HK1 / HK2 / HK3' },
      // { value: 'hk-mega', label: 'Hong Kong, iAdvantage MEGA-i' },
      // { value: 'sg-eq', label: 'Equinix SG1 / SG2 / SG3' },
      // { value: 'hk-gs', label: 'Global Switch Tai Seng' },
      // { value: 'eq-ty', label: 'Equinix TY6 / TY8 / TY9' },
      // { value: 'cs-la', label: 'CoreSite LA2' }
    ],
    table: {
      headers: {
        location: 'Location',
        vendor: 'Probe Vendor',
        host: 'Host',
        loss: 'Loss%',
        snt: 'Snt',
        last: 'Last',
        avg: 'Avg',
        best: 'Best',
        wrst: 'Wrst',
        stdev: 'StDev',
        chart: 'Chart'
      },
      noData: 'No data available'
    },
    button: {
      go: 'Go'
    }
  },
  trustedPartners: {
    title: 'Trusted by leading cloud platforms',
    altText: 'Platform Partner'
  }
}

// 中文翻译
const zh = {
  nav: {
    products: '产品',
    ipTransit: 'IP 传输',
    cloudVM: '云主机',
    bareMetal: 'Bare Metal',
    sdwan: 'SD-WAN',
    network: '网络',
    globalNetwork: '全球网络',
    locations: '服务器位置',
    latency: '延迟',
    ddosShield: 'DDoS 防护',
    company: '公司',
    about: '关于我们',
    careers: '招贤纳士',
    pricing: '价格',
  },
  footer: {
    product: '产品',
    network: '网络',
    company: '公司',
    support: '支持',
    terms: '条款',
    ipTransit: 'IP 传输',
    cloudVM: '云主机',
    bareMetal: 'Bare Metal',
    sdwan: 'SD-WAN',
    globalNetwork: '全球网络',
    locations: '服务器位置',
    latency: '延迟',
    ddosShield: 'DDoS 防护',
    about: '关于我们',
    careers: '招贤纳士',
    contactSupport: '联系支持',
    contactSales: '联系销售',
    documentation: '文档',
    networkStatus: '网络状态',
    termsOfService: '服务条款',
    compliance: '合规',
    privacyPolicy: '隐私政策',
    serviceLevel: '服务等级',
    systemStatus: '所有系统运行正常。',
    startTitle: '免费开始，随需扩展',
    requestTest: '申请测试',
    learnMore: '了解更多网络信息'
  },
  home: {
    motto: '客户. 信任. 沟通.',
    title: {
      line1: '助力企业成长',
      line2: '优质网络',
      line3: '保驾护航'
    },
    subtitle: '加速数字基础设施的未来',
    requestTest: '申请测试',
    learnMore: '了解更多网络信息',
    networkSection: {
      title: '强大的全球网络',
      subtitle: '全球分布式接入点，强大可靠的网络'
    },
    features: {
      isp: {
        title: '连接主要一二线 ISP.',
        desc: '无承诺即可访问全球一线 ISP 网络.'
      },
      scale: {
        title: '随时扩展.',
        desc: '大. 小. 扩展.'
      },
      ddos: {
        title: 'DDoS 防护.',
        desc: '在边缘阻止恶意流量.'
      },
      network: {
        title: '卓越网络，无与伦比的性能.',
        desc: '确保无缝连接、强大可靠性和卓越速度.'
      }
    },
    deploy: {
      title: '部署应用',
      subtitle: '更接近终端用户',
      desc: '我们的全球边缘与本地 ISP 相连，为终端用户带来最低延迟'
    },
    advantage: {
      title: '为什么选择我们?',
      desc: {
        line1: '低延迟、内置 DDoS 防护、24/7 双语支持,',
        line2: '通过优质网络实现全球连接.'
      },
      items: {
        latency: {
          title: '低延迟',
          desc: '最少跳数。最短路由。我们的网络为实时而生。'
        },
        ddos: {
          title: 'DDoS 防护',
          desc: '默认在边缘阻止恶意流量。'
        },
        support: {
          title: '全面支持',
          desc: '24/7 全天候中英文双语支持。'
        },
        reach: {
          title: '全球覆盖',
          desc: '通过我们的优质网络覆盖全球用户。'
        },
        ips: {
          title: '本地 IP',
          desc: '从本地 ISP 提供 IP 以满足连接需求。'
        },
        ixp: {
          title: 'IXP',
          desc: '在主要本地 IXP 交换流量。'
        },
        elastic: {
          title: '弹性扩展',
          desc: '随着业务增长，高度可扩展且经济实惠。'
        },
        dci: {
          title: 'DCI',
          desc: '数据中心互联速度高达 800Gbps。'
        }
      }
    },
    deployFeatures: {
      ipTransit: {
        title: 'IP 传输',
        description: '为网络运营商设计的先进全球 IP 传输服务。'
      },
      bareMetal: {
        title: '裸金属服务器',
        description: '由高性能处理器驱动的专用服务器。'
      },
      cloudVM: {
        title: '云主机',
        description: '高度可扩展且经济实惠的计算能力，起价5美元/月。'
      }
    }
  },
  pricing: {
    title: '简单定价',
    desc: {
      line1: '月度封顶和统一定价，费用清晰明了。',
      line2: '联系我们的销售团队获取定制方案。'
    },
    features: {
      credit: {
        title: '50美元额度',
        desc: '注册即可获得5美元额度，可用于60天内订购云主机。'
      },
      delivery: {
        title: '即时交付',
        desc: '多个位置，几分钟内即可使用。'
      },
      network: {
        title: '优质网络',
        desc: '面向数字基础设施未来的优质 IP 传输。'
      },
      performance: {
        title: '性能保障',
        desc: 'Intel® Xeon® 服务器确保性能和可靠性。'
      }
    },
    tabs: {
      network: '网络',
      compute: '计算'
    },
    ipTransit: {
      title: 'IP 传输',
      subtitle: '估算月度 IP 传输成本',
      commitment: 'Gbps 承诺',
      price: '美元/月，预付费',
      priceNote: '*承诺带宽将预先收费，而突发使用量将在下个月第一天计算并收费。',
      features: {
        loa: '一天内完成 LoA',
        support: '24/7 全天候支持',
        billing: '95百分位计费',
        storage: '对象存储'
      }
    },
    connect: {
      title: '连接我们的网络',
      subtitle: '很简单',
      desc: 'IP 传输在以下数据中心均可用—只需设置\n交叉连接即可与我们连接。',
      actions: {
        sales: '联系销售团队',
        test: '申请测试 LoA'
      }
    },
    compute: {
      name: '名称',
      vcpu: 'vCPU',
      ram: '内存',
      ssd: 'SSD',
      traffic: '流量',
      bandwidth: '带宽',
      monthly: '月付'
    }
  },
  network: {
    ddosShield: {
      title: 'DDoS 防护',
      subtitle: '默认启用',
      description: '在边缘阻止恶意流量。'
    },
    global: {
      title: {
        line1: '高可用性',
        line2: '网络拓扑'
      },
      subtitle: '加速数字基础设施的未来',
      buttons: {
        lookingGlass: '网络探测 >',
        peeringDB: 'PeeringDB >'
      },
      features: {
        redundantDesign: {
          title: '冗余设计',
          description: '多上游供给设计确保目标 ISP 的高可靠性。路由自动切换到可用路径。'
        },
        dci: {
          title: '数据中心互联',
          description: '自建 DCI 保证同城不同数据中心之间互联网连接不中断。'
        },
        monitoring: {
          title: '实时流量监控',
          description: '超过 50 个网络监控点，具有自动告警功能，动态路由确保流量通过最优路径传输。'
        },
        isps: {
          title: '连接主要本地 ISP',
          description: '与各地区顶级运营商直接连接，提升网络性能。'
        }
      },
      connect: {
        title: '更快连接全球',
        subtitle: '终端用户',
        description: '我们的全球边缘与本地 ISP 相连，为终端用户带来最低延迟'
      },
      easyConnect: {
        title: '连接我们的网络',
        subtitle: '很简单',
        description: 'IP 传输在以下数据中心均可用—只需设置\n交叉连接即可与我们连接。',
        buttons: {
          sales: '联系销售团队',
          test: '申请测试 LoA'
        }
      }
    },
    latency: {
      title: {
        line1: '近实时',
        line2: '性能'
      },
      subtitle: '加速数字基础设施的未来',
      buttons: {
        lookingGlass: '网络探测 >',
        peeringDB: 'PeeringDB >'
      }
    },
    locations: {
      title: {
        line1: '连接我们的网络',
        line2: '很简单'
      },
      subtitle: 'IP 传输在以下数据中心均可用—只需设置\n交叉连接即可与我们连接。',
      actions: {
        sales: '联系销售团队',
        test: '申请测试 LoA'
      }
    }
  },
  company: {
    about: {
      title: {
        line1: '亚太地区领先',
        line2: '的网络服务商'
      },
      subtitle: '加速数字基础设施的未来',
      stats: {
        upstreamFeed: {
          number: '3Tbps',
          label: '上游带宽'
        },
        networkCores: {
          number: '12',
          label: '网络核心'
        },
        connectedPeers: {
          number: '2000',
          label: '连接伙伴'
        },
        upstreamCapacity: {
          number: '3Tbps',
          label: '上游容量'
        }
      },
      sections: {
        coreProduct: '核心产品',
        networkFeeds: '网络供给',
        corePops: '核心节点'
      }
    },
    careers: {
      title: {
        line1: '加入我们',
        line2: '构建更好的网络'
      },
      subtitle: '在边缘阻止恶意流量。',
      features: {
        remote: {
          title: '完全远程',
          description: '远程工作无需打卡，无需繁琐的日报周报。',
          locations: {
            office: '办公室',
            home: '家庭',
            or: '或'
          }
        },
        benefits: {
          title: '具有竞争力的薪资',
          description: '具有竞争力的薪资和全面的福利，包括保险和住房公积金。',
          items: {
            salary: {
              title: '薪资',
              description: '优秀人才配优厚薪资。'
            },
            insurance: {
              title: '保险',
              description: '养老、医疗、失业、生育和工伤保险'
            },
            fund: {
              title: '公积金',
              description: '住房公积金'
            }
          }
        }
      },
      jobs: {
        title: '当前职位空缺',
        details: {
          jobType: '工作类型',
          location: '工作地点',
          headcount: '招聘人数'
        },
        positions: {
          procurement: {
            title: '采购助理',
            type: '全职',
            location: '成都/厦门',
            headcount: '1'
          },
          businessDev: {
            title: '商务拓展代表',
            type: '全职',
            location: '广州/深圳/北京',
            headcount: '3'
          }
        },
        talkButton: '联系我们'
      }
    }
  },
  products: {
    ipTransit: {
      title: {
        line1: '优质 IP 传输',
        line2: '全球覆盖'
      },
      subtitle: '加速数字基础设施的未来',
      buttons: {
        lookingGlass: '网络探测 >',
        peeringDB: 'PeeringDB >'
      },
      features: {
        latency: {
          title: '低延迟',
          description: '最少跳数。最短路由。我们的网络为实时而生。'
        },
        reach: {
          title: '全球覆盖',
          description: '通过我们的优质网络触达全球用户。'
        },
        elastic: {
          title: '弹性扩展',
          description: '随业务增长高度可扩展且经济实惠。'
        },
        ixp: {
          title: 'IXP',
          description: '在主要本地 IXP 交换流量。'
        }
      },
      network: {
        title: {
          line1: '更快连接全球',
          line2: '终端用户'
        },
        description: '我们的全球边缘与本地 ISP 相连，为终端用户带来最低延迟'
      },
      connect: {
        title: {
          line1: '连接我们的网络',
          line2: '很简单'
        },
        description: 'IP 传输在以下数据中心均可用—只需设置交叉连接即可与我们连接。',
        buttons: {
          sales: '联系销售团队',
          test: '申请测试 LoA'
        }
      },
      specs: {
        title: '技术规格',
        items: {
          commitment: {
            label: '承诺带宽',
            value: '100Mbps 至 3Tbps'
          },
          burstable: {
            label: '突发流量',
            value: '95百分位计费\n1:10比例'
          },
          crossConnect: {
            label: '交叉连接',
            value: '客户提供\n或预付一年'
          },
          fiber: {
            label: '光纤',
            value: '单模光纤，2芯'
          },
          connector: {
            label: '连接器类型',
            value: 'LC'
          },
          lacp: {
            label: 'LACP',
            value: '支持'
          },
          bgp: {
            label: 'BGP',
            value: 'BGP 全表'
          },
          bgpCommunities: {
            label: 'BGP Communities',
            value: 'BGP Communities 根据服务类型变化'
          },
          ddos: {
            label: 'DDoS 防护',
            value: '默认 10Gbps 防护\n最高 1Tbps DDoS 防护能力'
          },
          ipv4: {
            label: 'IPv4',
            value: '客户提供\n或 AS9886 提供，每个 /24 150美元\n或联系销售团队了解更多详情'
          },
          ipv6: {
            label: 'IPv6',
            value: '客户提供\n或免费提供一个 /48'
          }
        }
      }
    },
    sdwan: {
      title: {
        line1: '扩展 SD-WAN',
        line2: '覆盖范围'
      },
      subtitle: 'SD-WAN 赋能器使客户能够快速扩展其全球网络覆盖范围。可扩展的骨干网和 IPLC，或提供增强的 SaaS 加速服务，CTCSCI 提供全面的解决方案。',
      features: {
        premiumNetwork: {
          title: '优质网络',
          description: 'SDN 骨干网提供低延迟、高可靠性和受保护的连接，确保卓越的服务性能和稳定性。',
          stats: {
            hkToSg: '香港至新加坡',
            hkToTokyo: '香港至东京',
            tokyoToSeoul: '东京至首尔',
            hkToSeoul: '香港至首尔',
            cnToHk: '大陆至香港',
            cnToTokyo: '中国至东京',
            cnToUs: '中国至美国',
            cnToSg: '中国至新加坡'
          },
          tabs: {
            backbone: '骨干网',
            iplc: 'IPLC'
          }
        },
        globalCoverage: {
          title: '全球覆盖',
          description: '广泛的全球专线覆盖和丰富的节点阵列完全满足您所有的基础设施资源需求。'
        },
        flexibleDeployment: {
          title: '灵活部署',
          description: '随业务增长实现快速部署和灵活扩展。支持包括 BMC 和 VM 在内的各种部署选项。',
          options: {
            bareMetal: '裸金属',
            cloudVM: '云虚拟机'
          }
        },
        compliance: {
          title: '合规认证',
          description: '全面的资源和运营资质确保跨境运营合规。',
          certs: {
            iso27001: {
              name: 'ISO27001',
              number: '416Z4ISZ060ZR0'
            },
            iso9001: {
              name: 'ISO9001',
              number: '416Z4QZ636ZER0'
            },
            sro: {
              name: 'SRO',
              number: 'No.1906'
            }
          }
        }
      }
    },
    cloudVM: {
      title: {
        line1: '云端无限灵活',
        line2: '按需扩展'
      },
      subtitle: '无缝虚拟计算，具有无与伦比的可扩展性和灵活性。',
      features: {
        locations: {
          title: '10+ 数据中心',
          description: '裸金属服务器部署在10个数据中心'
        },
        delivery: {
          title: '即时交付',
          description: '多个位置，几分钟内即可使用。'
        },
        network: {
          title: '优质网络',
          description: '面向数字基础设施未来的优质 IP 传输。'
        },
        performance: {
          title: '性能保障',
          description: 'Intel® Xeon® 服务器确保性能和可靠性。'
        }
      },
      apacNetwork: {
        title: {
          line1: '低延迟优质网络',
          line2: '保驾护航'
        },
        description: {
          line1: '通过我们不断扩展的网络和数据中心布局，实现即时的本地',
          line2: '和全球覆盖，提供近实时的精确服务。'
        },
        button: '了解更多关于我们的覆盖'
      },
      dataCenters: {
        hongKong: {
          name: '中国香港',
          detail: '2个数据中心提供裸金属服务'
        },
        singapore: {
          name: '新加坡',
          detail: '3个数据中心提供裸金属服务'
        }
      },
      pricing: {
        title: {
          line1: '更多资源',
          line2: '更低成本'
        },
        description: '与行业竞争对手相比，获得更多流量和带宽，成本更低。',
        button: '查看云主机价格',
        bestChoice: '最佳选择',
        comparison: {
          specs: '1 vCPU, 1GB, 25GB',
          bandwidth: '带宽',
          network: '10Gbps',
          price: '5美元/月'
        },
        competitors: {
          digitalOcean: {
            specs: '1 vCPU, 1GB, 25GB',
            bandwidth: '带宽 1TB',
            network: '1Gbps',
            price: '5美元/月'
          },
          vultr: {
            specs: '1 vCPU, 1GB, 25GB',
            bandwidth: '带宽 1TB',
            network: '1Gbps',
            price: '6美元/月'
          },
          zenlayer: {
            specs: '1 vCPU, 2GB, 25GB',
            bandwidth: '带宽 1TB',
            network: '1Gbps',
            price: '17.272美元/月'
          }
        }
      }
    },
    bareMetal: {
      title: {
        line1: '无与伦比的边缘',
        line2: '性能'
      },
      subtitle: '裸金属服务器部署在10个数据中心，分钟级部署。',
      features: {
        locations: {
          title: '10+ 数据中心',
          description: '裸金属服务器部署在10个数据中心'
        },
        delivery: {
          title: '即时交付',
          description: '多个位置，几分钟内即可使用。'
        },
        network: {
          title: '优质网络',
          description: '面向数字基础设施未来的优质 IP 传输。'
        },
        performance: {
          title: '性能保障',
          description: 'Intel® Xeon® 服务器确保性能和可靠性。'
        }
      },
      reachUsers: {
        title: '快速触达新兴市场用户',
        subtitle: '一家领先的中国 CDN 提供商通过 AS9886 将东盟地区终端用户的延迟降低了 50%。',
        button: '查看裸金属价格'
      },
      apacNetwork: {
        title: {
          line1: '低延迟优质网络',
          line2: '保驾护航'
        },
        description: {
          line1: '通过我们不断扩展的网络和数据中心布局，实现即时的本地',
          line2: '和全球覆盖，提供近实时的精确服务。'
        },
        button: '了解更多关于我们的覆盖'
      },
      dataCenters: {
        hongKong: {
          name: '中国香港',
          detail: '2个数据中心提供裸金属服务'
        },
        singapore: {
          name: '新加坡',
          detail: '3个数据中心提供裸金属服务'
        }
      },
      useCases: {
        title: {
          line1: '为您的使用场景定制',
          line2: '性能'
        },
        cases: {
          business: {
            title: '企业',
            description: '适用于企业网站和 API 托管。'
          },
          vps: {
            title: 'VPS 托管',
            description: '默认在边缘阻止恶意流量。'
          },
          gaming: {
            title: '游戏',
            description: '运行游戏的最快平台。'
          },
          cdn: {
            title: 'CDN',
            description: '到香港交易所最低延迟 0.5ms。'
          },
          crypto: {
            title: '加密货币',
            description: '为金融未来准备的基础设施'
          }
        }
      },
      specifications: {
        title: '技术规格',
        items: {
          cpu: {
            label: 'CPU',
            value: 'Intel Xeon E / Silver / Gold'
          },
          cores: {
            label: '核心数',
            value: '最高 32 核'
          },
          ram: {
            label: '内存',
            value: '最高 384 GB'
          },
          storage: {
            label: '存储',
            value: 'SSD / NVMe / HDD'
          },
          network: {
            label: '网络接口',
            value: '1Gbps / 10Gbps / 25Gbps, 以太网'
          },
          ipv4: {
            label: 'IPv4',
            value: '1个免费 IPv4 地址'
          },
          ipv6: {
            label: 'IPv6',
            value: '/64 IPv6 地址'
          },
          traffic: {
            label: '流量',
            value: '无限制'
          },
          bandwidth: {
            label: '带宽',
            value: '前 50Mbps 免费，额外带宽按需分配'
          },
          customization: {
            label: '定制',
            value: '联系销售团队'
          }
        }
      }
    }
  },
  terms: {
    service: {
      title: '服务条款',
      menu: {
        definition: '项目与定义',
        rights: '双方的权利和义务',
        serviceContent: '服务内容、费用及支付方法',
        period: '合同期限',
        changes: '业务变更、合同解除、终止',
        breach: '违约责任',
        dispute: '争议解决',
        force: '不可抗力',
        confidential: '保密',
        rightsReserve: '权利保留',
        notification: '通知',
        law: '法律适用',
        effective: '生效条件及其它'
      },
      content: {
        definition: {
          title: '项目与定义',
          text: [
            '本服务条款构成 wanix 与您之间的合同。条款包括在本文档和 wanix 隐私条款，以及其他可能不时向您提供并且您接受的与特定服务产品相关的条款或条件（我们将这些统称为"服务条款"或"条款"）。一经注册或使用我们的服务，您将被视为接受本条款并同意成为本具有约束力的合同的一方。',
            '您，帐户所有人，是合同的一方，以下以"您"或"你"等第二人称代指。wanix，即"杭州包子信息科技有限公司"向您提供服务，是合同的另一方，以"我"、"我们"或其他第一人称代指。',
            'wanix 软件（定义如下），wanix 服务以及由 wanix 托管或提供的其他产品、服务和网站，比如，包括我们的管理后台及帮助与/或条款中提及的"服务"。通过它们，您可以在网络设备和系统上完成很多想做的事（统称为"服务"）。作为能够使用本服务的交换，您同意遵守本条款。',
            '随着新功能、技术的出现或者法律法规的要求，本条款可能会有修订，所以请不时进行查看。如果我们做了重要的变更调整，我们会通知你，并且在必要时征询你的同意。如果我们更新本条款，您有权决定接受更新的条款或停止使用我们的服务（见下文"如何关闭我的帐户"）；您在更新生效之后继续使用本服务之行为，将视为您就新条款与我方达成一致并同意受其约束。除此处所述的由我们做出的变更外，对这些条款的任何其他修订或修改均无效，除非你我双方在明确修订这些条款并且有书面签字的书面协议中另有规定。为清楚起见，出于此目的，电子邮件或其他通信将不构成有效的书面协议。',
            '如果你与 wanix 另签订书面合同，则以书面合同内容为准。'
          ]
        },
        rights: {
          title: '双方的权利和义务',
          subtitle: '您的权利与义务',
          text: [
            '您在使用中华人民共和国服务器时，承诺遵守《计算机信息网络国际联网安全保护管理办法》、《中华人民共和国计算机信息网络国际联网管理暂行规定》、《中华人民共和国电信条例》、《全国人大常委会关于维护互联网安全的决定》、《互联网信息服务管理办法》、《互联网站从事文化管理暂行规定》和国家其它有关法律、法规、行政规定、行政规章，不得制作、复制、发布、传播任何法律、法规所禁止的有害信息。您对您的经营行为和发布的信息违反上述规定而引起的任何政治责任、法律责任和给我们造成的经济损失承担全部责任。',
            '您承诺不会利用 wanix 提供的服务从事互联网上为国家法律、法规或公共道德所禁止的或不欢迎的活动，同时承诺不为他人发布上述不符合国家规定和/或本条款约定的信息内容提供任何便利。您了解我们有权根据我们自己谨慎的判断来决定您发布的内容是否构成违反使用条款或者国家的有关规定并据此停止您的服务，由此引起的后果由您承担，上述活动和信息包括但不限于：'
          ]
        }
      }
    }
  },
  essentialFeatures: {
    title: {
      line1: '云端所有',
      line2: '基础功能'
    },
    subtitle: {
      line1: "完整的基础功能套件，满足广泛的",
      line2: "业务和运营需求"
    },
    features: [
      '即时交付',
      '高性能',
      '低延迟',
      'ZStack 支持',
      '延迟优化',
      '备份和快照',
      '浮动 IP',
      '多种 Linux 镜像',
      '对象存储',
      '负载均衡',
      'DDoS 防护',
      '24 x 7 全天候支持'
    ]
  },
  globalPresence: {
    apac: {
      title: {
        line1: '覆盖亚太地区',
        line2: '及更多区域'
      },
      description: {
        line1: '通过我们不断扩展的网络和数据中心布局，',
        line2: '实现即时的本地和全球覆盖，提供近实时的精确服务。'
      },
      button: '了解更多关于我们的覆盖'
    },
    locations: {
      hongKong: {
        name: '中国香港',
        services: 'IP传输, 云主机, 裸金属服务器'
      },
      singapore: {
        name: '新加坡',
        services: 'IP传输, 云主机, 裸金属服务器'
      },
      seoul: {
        name: '韩国首尔',
        services: 'IP传输'
      },
      losAngeles: {
        name: '美国洛杉矶',
        services: 'IP传输, 云主机'
      },
      tokyo: {
        name: '日本东京',
        services: 'IP传输, 云主机'
      },
      jakarta: {
        name: '印尼雅加达',
        services: '即将推出'
      }
    }
  },
  latencyComparison: {
    tabs: {
      before: '优化前',
      after: '优化后'
    },
    label: '延迟',
    countries: {
      indonesia: '印度尼西亚',
      malaysia: '马来西亚',
      philippines: '菲律宾',
      singapore: '新加坡',
      thailand: '泰国',
      vietnam: '越南'
    },
    ddos: {
      title: 'DDoS 防护.',
      description: '成功缓解多次 DDoS 攻击，处理峰值流量 500Gbps。'
    }
  },
  networkConnect: {
    table: {
      headers: {
        city: '城市',
        dataCenter: '数据中心',
        portAvailability: '端口可用性'
      }
    },
    locations: {
      hongKong: {
        name: '香港',
        centers: [
          'Equinix HK1 / HK2 / HK3',
          'iAdvantage MEGA-i',
          'iAdvantage MEGA Two',
          'iAdvantage MEGA Gateway',
          'HKColo'
        ]
      },
      singapore: {
        name: '新加坡',
        centers: [
          'Equinix SG1 / SG2 / SG3',
          'Global Switch Tai Seng',
          'China Mobile International Tai Seng'
        ]
      },
      tokyo: {
        name: '东京',
        centers: ['Equinix TY6 / TY8 / TY9']
      },
      losAngeles: {
        name: '洛杉矶',
        centers: ['CoreSite LA2']
      }
    },
    portType: '10G / 100G, 光纤'
  },
  networkLatency: {
    title: {
      line1: '检测网络延迟',
      line2: '连接主要网络'
    },
    description: '检测从我们的网络到全球主要 ISP 的延迟。您也可以使用 https://check.my/mtr/ctcsci 工具获取从我们的网络到目标 IP 的路由详情。',
    locations: [
      { value: '103.77.210.191', label: 'Equinix HK1' },
      { value: '104.251.232.134', label: 'Singpore, Equinix SG1' },
      { value: '104.251.228.141', label: 'Tokyo, Equinix TY8' },
      { value: '104.251.238.134', label: 'Los Angeles, CoreSite LA2' },
      // { value: 'hk-eq1', label: 'Equinix HK1 / HK2 / HK3' },
      // { value: 'hk-mega', label: 'Hong Kong, iAdvantage MEGA-i' },
      // { value: 'sg-eq', label: 'Equinix SG1 / SG2 / SG3' },
      // { value: 'hk-gs', label: 'Global Switch Tai Seng' },
      // { value: 'eq-ty', label: 'Equinix TY6 / TY8 / TY9' },
      // { value: 'cs-la', label: 'CoreSite LA2' }
    ],
    table: {
      headers: {
        location: '位置',
        vendor: '探测供应商',
        host: '主机',
        loss: '丢包率',
        snt: '发送',
        last: '最新',
        avg: '平均',
        best: '最佳',
        wrst: '最差',
        stdev: '标准差',
        chart: '图表'
      },
      noData: '暂无数据'
    },
    button: {
      go: '检测'
    }
  },
  trustedPartners: {
    title: '受到领先云平台的信任',
    altText: '平台合作伙伴'
  }
}

export const translations = {
  en,
  zh
}

export function useTranslation() {
  const currentLang = localStorage.getItem('language') || 'en'
  
  const t = (key) => {
    const keys = key.split('.')
    let result = translations[currentLang]
    
    for (const k of keys) {
      if (result && result[k]) {
        result = result[k]
      } else {
        return key
      }
    }
    
    return result
  }
  
  return { t }
} 